import React from 'react';
import { Button, Col, Row } from 'reactstrap';
import Styles from './Main.module.css';
import AiPowerImage from "./assets/ai-power.png";
import CameraSnapIcon from "./assets/camera-snap.png";
import LightBulbIcon from "./assets/light-bulb.png";
import BlockChainIcon from "./assets/block-chain.png";
import useProjectSteps from '../../../../../hooks/useProjectSteps';

function MainCard() {
  const projectSteps = useProjectSteps();

  const handlePhotoUpload = () => {
    // For now, redirect to the step1 of project creation
    projectSteps.goFirstStep();
  }

  return (
    <div>
      <div className={Styles.roundedDiv}>
        <Row>
          <div className='text-center'>
            <h2 className={`display-6 ${Styles.headerMessage}`}>Fixing the Broken<br />Renovation Industry</h2>
          </div>
        </Row>
        <Row>
          <div className='text-center'>
            <small className={Styles.smallMessage}>AI designs your dream space, Blockchain protects your money</small>
          </div>
        </Row>
        <Row>
          <div>
            <img className='w-100 rounded-3' src={AiPowerImage} alt="AI powered" />
          </div>
        </Row>
        <Row>
          <div className='text-center pt-3'>
            <Button
              variant="secondary"
              className={`ml-auto text-white text-bold d-inline-flex align-items-center px-4 py-3 bg-transparent border-0 ${Styles.buttonGradient}`}
              onClick={() => handlePhotoUpload()}
            >
              Upload Your Photo
            </Button>
          </div>
        </Row>
        <Row>
          <div className='text-center'>
            <small className={Styles.uploadButtonHint}>Watch Your Space Transform</small>
          </div>
        </Row>
      </div>
      <Row>
        <Col className='align-content-center text-center' xs="4">
          <img className='w-75 p-3' src={CameraSnapIcon} alt="" />
        </Col>
        <Col className='align-content-center text-center' xs="4">
          <img className='w-75 p-3' src={LightBulbIcon} alt="" />
        </Col>
        <Col className='align-content-center text-center' xs="4">
          <img className='w-75 p-3' src={BlockChainIcon} alt="" />
        </Col>
      </Row>
      <Row className='font-helvetica-world'>
        <Col xs="4" className='text-center'>
          <p className='mb-0'><b>Snap + Upload</b></p>
          <span>a photo of your space.</span>
        </Col>
        <Col xs="4" className='text-center'>
          <p className='mb-0'><b>AI Generates ideas.</b></p>
          <span>Get design options and bill of materials.</span>
        </Col>
        <Col xs="4" className='text-center'>
          <p className='mb-0'><b>Blockchain Secures Payments.</b></p>
          <span>Hire a contractor safely.</span>
        </Col>
      </Row>
    </div>
  );
}

export default MainCard;
